import { API_URL } from '@/src/lib/core/config';

function appendQueryParams(query: { [key: string]: number | string }, url: URL) {
  Object.keys(query).forEach((key) => {
    if (query && query[key]) {
      url.searchParams.set(key, String(query[key]));
    }
  });

  return url;
}

export function getGlueUrl(path: string, options?: { query?: { [key: string]: number | string } }) {
  const url = new URL(path, API_URL);

  if (options?.query) {
    appendQueryParams(options.query, url);
  }

  return String(url);
}
